import React, { useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Button } from 'devextreme-react/button';
import { Close } from '@material-ui/icons';
import { CheckBox, NumberBox, SelectBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function CustomerDialog(props) {
  const { editMode, operation, title, open, onClose, handleOnClick, dialogSize, dataForm, onChange } = props;
  const [phoneMask, setPhoneMask] = useState('+00 (00) 0000-0000');

  const handleMaskChange = (e) => {
    const value = e.value || '';
    if (value.startsWith('+')) {
      setPhoneMask('+00 (00) 0000-0000'); // International format
    } else {
      setPhoneMask('(00) 0000-0000'); // Local format
    }
  };

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles" style={{ color: 'white', minHeight: '20px', backgroundColor: '#3B5158', marginBottom: '15px', paddingBlock: '12px' }}>
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            {' '}
            <Close style={{ color: 'white' }} />{' '}
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <InputWrapper label={'CNPJ*'}>
            <TextBox
              key={'CNPJ'}
              //disabled={editMode}
              name="CNPJ"
              mask="00.000.000/0000-00"
              placeholder="00.000.000/0000-00"
              showMaskMode="onFocus"
              maskRules={{ 0: /[0-9]/ }}
              value={dataForm?.CNPJ}
              onValueChanged={(e) => onChange('CNPJ', e.value)}
              height={25}
            ></TextBox>
          </InputWrapper>
          <InputWrapper label={'Razão Social*'}>
            <TextBox key={'CustomerName'} name="CustomerName" value={dataForm?.CustomerName} onValueChanged={(e) => onChange('CustomerName', e.value)} height={25}></TextBox>
          </InputWrapper>
          <InputWrapper label={'Telefone*'}>
            <TextBox key={'Phone'} name="Phone" value={dataForm?.Phone} onValueChanged={(e) => onChange('Phone', e.value)} height={25}></TextBox>
            {/* <NumberBox
              key={'Phone'}
              name="Phone"
              //mask="#"
              //   placeholder="+55..."
              // maskRules={{ 'h': /[0-9+]/ }}
              //   mask={phoneMask}
              //   maskChar="_"
              //   onValueChanged={handleMaskChange}
              value={dataForm?.Phone}
              onValueChanged={(e) => onChange('Phone', e.value)}
              height={25}
            ></NumberBox> */}
          </InputWrapper>
          <InputWrapper label={'E-mail'}>
            <TextBox mode="email" key={'Email'} name="Email" value={dataForm?.Email} onValueChanged={(e) => onChange('Email', e.value)} height={25}></TextBox>
          </InputWrapper>
          <InputWrapper label={'CEP'}>
            {/* <NumberBox key={'CEP'} name="CEP" format="00000-000" mask="00000-000" maskRules={{ '0': /[0-9]/ }} maskChar="_" placeholder="00000-000" value={dataForm?.CEP} onValueChanged={(e) => onChange('CEP', e.value)} height={25}></NumberBox> */}
            {/* <NumberBox key={'CEP'} name="CEP" inputAttr={{ 'maxlength': 8 }} value={dataForm?.CEP} onValueChanged={(e) => onChange('CEP', e.value)} height={25}></NumberBox> */}
            <TextBox key={'CEP'} name="CEP" maxLength={8} value={dataForm?.CEP} onValueChanged={(e) => onChange('CEP', e.value)} height={25}></TextBox>
          </InputWrapper>
          <InputWrapper label={'Endereço'}>
            <TextBox key={'Address'} name="Address" value={dataForm?.Address} onValueChanged={(e) => onChange('Address', e.value)} height={25}></TextBox>
          </InputWrapper>
          <InputWrapper label={'Representante legal'}>
            <TextBox key={'LegalRepresentative'} name="LegalRepresentative" value={dataForm?.LegalRepresentative} onValueChanged={(e) => onChange('LegalRepresentative', e.value)} height={25}></TextBox>
          </InputWrapper>
          <InputWrapper label={'Cliente Cadastrado?'}>
            <CheckBox value={dataForm?.isValid != null ? dataForm?.isValid : false} onValueChanged={(e) => onChange('isValid', e.value)} />
          </InputWrapper>
        </DialogContent>
        <DialogActions>
          {operation === 'delete' ? (
            <>
              <Button onClick={onClose} style={buttonStyles}>
                Cancelar
              </Button>
              <Button onClick={handleOnClick} style={buttonStyles}>
                Salvar
              </Button>
            </>
          ) : (
            <Button onClick={handleOnClick} style={buttonSaveStyles}>
              Editar
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default CustomerDialog;
